import React from 'react';

interface ProgressIndicatorProps {
    current: number;
    total: number;
    onDotClick: (index: number) => void;
}

/** "Slide X of Y" label + clickable animated dot pagination. */
const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ current, total, onDotClick }) => {
    return (
        <div className='flex items-center gap-3'>
            <span className='whitespace-nowrap text-xs font-medium text-gray-400'>
                Slide {current + 1} of {total}
            </span>
            <div className='flex items-center gap-1.5' role='tablist' aria-label='Slides'>
                {Array.from({ length: total }).map((_, i) => (
                    <button
                        key={i}
                        type='button'
                        role='tab'
                        aria-selected={i === current}
                        aria-label={`Go to slide ${i + 1}`}
                        onClick={() => onDotClick(i)}
                        className='h-1.5 rounded-full transition-all duration-300'
                        style={{
                            width: i === current ? 24 : 6,
                            backgroundColor: i === current ? '#00aae5' : '#e2e2e2',
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProgressIndicator;
